/**
 * V0 Surcharge configuration.
 * Retailer IDs allowed to bypass excluded postcode blocking and use surcharge flow.
 * This must be kept in sync with the backend config:
 *   retailer-api/src/config/surcharge_config.ts
 */
export const SURCHARGE_ALLOWED_RETAILER_IDS = [
  5553, 9855, 9413, 20720, 3985, 12177, 21244, 27807, 33451, 15650, 2911, 5382,
  23038, 21195, 26589, 4170, 10048, 18877, 9987, 21203,
  15799, 26049, 14297,
];
